import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { GroupsResponse } from '@utils/types/organization/group.ts';

async function groups(): Promise<GroupsResponse> {
  const { data } = await Axios.get(GET_URL().groups);
  return data;
}

export function useGetGroups(
  options?: UseQueryOptions<
    GroupsResponse,
    AxiosError<BaseError>,
    GroupsResponse
  >
) {
  return useQuery<GroupsResponse, AxiosError<BaseError>>(
    ['groups'],
    () => groups(),
    {
      ...options,
      retry: false,
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: (error: AxiosError<BaseError>) => {
        // Don't log 403 errors to Sentry - it's expected for users without group access
        // The component handles this gracefully by using groups?.result || []
        if (error?.response?.status === 403) {
          return;
        }
        // For other errors, let the global error handler manage them
      }
    }
  );
}
